import contractStore from './store/contract'

export default {
  install (Vue, { store }) { // now your plugin depend on store
    if (store) {
      store.registerModule('contract', contractStore)
    }
  }
}
